export default __webpack_public_path__ + "static/media/camera.759dd544.svg";